var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img",style:(_vm.imgStyle),attrs:{"src":this.imageUrl,"alt":"teacherImage"},on:{"mouseover":_vm.mouseover,"mouseleave":_vm.mouseleave}})])}
var staticRenderFns = []

export { render, staticRenderFns }